import { React, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router";
import { Formik } from "formik";
import * as Yup from "yup";

import { MappixDesign } from "../";
import * as commonApi from "../../../api/commonApi";
import { Common, CommonPages, DataType, EditProfileConstants, Regex, SessionStorageKeys, VALIDATION } from "../../../helper";
import { isEmptyObject, SessionStorage } from "../../../util";
import { clearStore } from "../../..";

import "../../../assets/stlyes/Common/LoginNew.scss";

import Account from "../../../assets/images/IconAccount.png";
import HideVisibility from "../../../assets/images/IconNotVisible1.png";
import ShowVisibility from "../../../assets/images/IconVisible1.png";
import HexagonCharacter from "../../../assets/images/HexagonCharacter.png";

const SetNewPassword = () => {
  const emailRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const navigate = useNavigate();
  const [inputType, setInputType] = useState(DataType.Password)
  const [btnImage, setBtnImage] = useState(HideVisibility);
  const [inputTypeNew, setInputTypeNew] = useState(DataType.Password)
  const [btnImageNew, setBtnImageNew] = useState(HideVisibility);

  const PasswordUpdateValidationSchema = Yup.object().shape({
    newPassword: Yup.string().required(Common.Required).matches(Regex.PasswordRegExp, Common.PasswordsMustContain).min(8, VALIDATION.PASSWORD_MUST_HAVE_MINIMUM_8_CHARACTERS),
    confirmPassword: Yup.string().oneOf([Yup.ref("newPassword"), null], VALIDATION.PASSWORD_MUST_MATCH).required(VALIDATION.CONFIRM_PASSWORD_IS_REQUIRED)
  });

  const _togglePasswordVisibility = () => {
    if (inputType === DataType.Password) {
      setBtnImage(ShowVisibility);
      setInputType(DataType.Text);
    }
    if (inputType === DataType.Text) {
      setBtnImage(HideVisibility);
      setInputType(DataType.Password)
    }
  }

  const _toggleNewPasswordVisibility = () => {
    if (inputTypeNew === DataType.Password) {
      setBtnImageNew(ShowVisibility);
      setInputTypeNew(DataType.Text);
    }
    if (inputTypeNew === DataType.Text) {
      setBtnImageNew(HideVisibility);
      setInputTypeNew(DataType.Password)
    }
  }

  const password = async (formData) => {
    const updatePassword = await commonApi.setNewPassword(formData);
    if (!isEmptyObject(updatePassword.Items)) {
      clearStore();
      SessionStorage.clearAll();
      navigate(CommonPages.login)
      window.location.reload()
    }
  }

  return (
    <>
      <div className="main-login">
        <div className="left-part">
          <div className="first-div"><MappixDesign /></div>
        </div>
        <div className="right-part">
          <div className="first-div">
            <h3 className="welcome-title">{Common.SetPassword}</h3>
            <Formik initialValues={{ email: SessionStorage.getItem(SessionStorageKeys.NewPasswordEmail), newPassword: "", confirmPassword: "", }} validationSchema={PasswordUpdateValidationSchema}
              validate={() => { const errors = {}; return errors; }} onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                const formData = { password: values.newPassword }; password(formData);
              }}>
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <div className="profile-form">
                  <Form onSubmit={handleSubmit} className="profileForm">
                    <Form.Group>
                      <Form.Label>{Common.Email}</Form.Label>
                      <Form.Control id="userNamePlaceholder" type="email" name="email" placeholder={Common.EmailExample} onChange={handleChange} onBlur={handleBlur} value={values.email} className={touched.email && errors.email ? "user_email" : "user_email_active"} ref={emailRef} autoComplete="off" disabled />
                      <img src={Account} alt="Acc" className="AcoountLogo" />
                      {touched.email && errors.email ? (<p className="error-message">{errors.email}</p>) : <p>{""}</p>}
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>{Common.EnterNewPassword}</Form.Label>
                      <Form.Control type={inputType} name="newPassword" id="newPassword" placeholder="Password" onChange={handleChange} onBlur={handleBlur} value={values.newPassword} className={touched.newPassword && errors.newPassword ? "user_password" : "user_password_active"} ref={newPasswordRef} autoComplete="off" />
                      <span onClick={_togglePasswordVisibility} onKeyDown={(e) => (e.key === "Enter" && _togglePasswordVisibility())} tabIndex={0} role="button"><img src={btnImage} alt="Acc" className="visibleLogo" /></span>
                      {touched.newPassword && errors.newPassword && (<p className="error-message-new-password">{errors.newPassword}</p>)}
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>{Common.ConfirmNewPassword}</Form.Label>
                      <Form.Control type={inputTypeNew} name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" onChange={handleChange} onBlur={handleBlur} value={values.confirmPassword} className={touched.confirmPassword && errors.confirmPassword ? "user_password" : "user_password_active"} ref={confirmPasswordRef} autoComplete="off" />
                      <span onClick={_toggleNewPasswordVisibility} onKeyDown={(e) => (e.key === "Enter" && _toggleNewPasswordVisibility())} tabIndex={0} role="button"><img src={btnImageNew} alt="Acc" className="visibleLogo" /></span>
                      {touched.confirmPassword && errors.confirmPassword && (<p className="error-message">{errors.confirmPassword}</p>)}
                    </Form.Group>
                    <Form.Group className="submit-button-div ">
                      <button type="submit" className="submit-button">{EditProfileConstants.UpdatePassword}</button>
                    </Form.Group>
                  </Form>
                </div>
              )}
            </Formik>
          </div>
          <div className="second-div"><img src={HexagonCharacter} className="hexagon-logo" alt="hexagon-character"></img></div>
        </div>
      </div >
    </>
  );
}

export { SetNewPassword };
